import { render, staticRenderFns } from "./teacherMatingDetailModule.vue?vue&type=template&id=bb2ba0fa&scoped=true&"
import script from "./teacherMatingDetailModule.vue?vue&type=script&lang=js&"
export * from "./teacherMatingDetailModule.vue?vue&type=script&lang=js&"
import style0 from "./teacherMatingDetailModule.vue?vue&type=style&index=0&id=bb2ba0fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2ba0fa",
  null
  
)

export default component.exports